module.exports = __webpack_public_path__ + "img/cubfan135-31ef549d-2c1f-4bb9-4898-08d95b7e528f.png";